/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientNavigatorServiceModel } from '../../models/patient-navigator-service-model';

export interface PatientNavigatorServicesGet$Params {
}

export function patientNavigatorServicesGet(http: HttpClient, rootUrl: string, params?: PatientNavigatorServicesGet$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<Array<PatientNavigatorServiceModel>>> {
  const rb = new RequestBuilder(rootUrl, patientNavigatorServicesGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<Array<PatientNavigatorServiceModel>>;
    })
  );
}

patientNavigatorServicesGet.PATH = '/PatientNavigator/Services';
